export default "/img/infoceanus.3400112b9787ebb7e4ced2ae556196b4.png";